import { useTranslation } from 'react-i18next';
import { MarketWarning } from 'newcomponents/Shared/sportsbook/MarketWarning';
import { NoDataIconWrapper } from 'newcomponents/UI/NoDataIconWrapper';

export const EmptyMarketsView = () => {
  const { t } = useTranslation();

  return (
    <div className="noMarketsWrapper">
      <NoDataIconWrapper />
      <div className="noMarketsWrapper__title">{t('sportsbook.noMarkets')}</div>
      <MarketWarning />
    </div>
  );
};
